__turbopack_context__.v({
  "arrow": "HorizontalRow-module__K5w85G__arrow",
  "left": "HorizontalRow-module__K5w85G__left",
  "leftGradient": "HorizontalRow-module__K5w85G__leftGradient",
  "right": "HorizontalRow-module__K5w85G__right",
  "rightGradient": "HorizontalRow-module__K5w85G__rightGradient",
  "slider": "HorizontalRow-module__K5w85G__slider",
  "sliderWrapper": "HorizontalRow-module__K5w85G__sliderWrapper",
  "title": "HorizontalRow-module__K5w85G__title",
  "viewMore": "HorizontalRow-module__K5w85G__viewMore",
});
